<div class="row g-3 p-3">
  <div class="col-4 tw-cursor-pointer" *ngFor="let city of cities">
    <div class="card p-2 d-flex align-items-center" (click)="onCitySelected(city)">
      <img src="{{city.icon}}" class="tw-aspect-square tw-w-8" alt="" srcset="">
      <p class="mb-0" style="font-size: small;">{{city.name | titlecase}}</p>
    </div>
  </div>
  <ng-container *ngIf="isLoading">
    <app-item-loader></app-item-loader>
  </ng-container>
</div>